export { default } from './TabItems';
export { TabItemsProps } from './TabItems.types';
